import { useAuth } from "../../auth/AuthContext";
import { useBrand } from "../../brand/BrandContext";
import murrayAvatar from "../../assets/murray-avatar-badge-180.png";
import { SearchBar } from "./SearchBar";

export function Header() {
  const { user, logout } = useAuth();
  const { brandName } = useBrand();
  const locationLabel = brandName ? brandName.replace(/^Sir Grout\s+/i, "") : "Location";

  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/95 backdrop-blur">
      <div className="flex min-h-14 flex-col gap-3 px-4 py-2.5 md:min-h-16 md:flex-row md:items-center md:px-6 md:py-3">
        <div className="flex min-w-[190px] items-center gap-3">
          <img
            alt="Murray"
            className="h-10 w-10 rounded-full border border-blue-100 bg-white object-cover shadow-sm"
            src={murrayAvatar}
          />
          <div>
            <div className="text-xs font-semibold uppercase tracking-[0.16em] text-[#11133f] md:text-sm md:tracking-[0.18em]">
              Murray Ops
            </div>
            <div className="text-xs text-slate-500">{locationLabel} operations dashboard</div>
          </div>
        </div>

        <div className="hidden flex-1 md:block">
          <SearchBar />
        </div>

        <div className="flex items-center gap-2 md:ml-auto">
          <div className="hidden h-9 items-center gap-2 rounded-md border border-blue-100 bg-slate-50 px-3 text-sm font-medium text-[#1c2b4a] md:inline-flex">
            {locationLabel}
            <span aria-hidden="true">v</span>
          </div>
          {user ? (
            <div className="flex items-center gap-2">
              <div className="hidden text-right md:block">
                <div className="text-xs font-medium text-slate-900">{user.full_name || user.username}</div>
                <div className="text-[10px] uppercase tracking-[0.14em] text-slate-500">{user.role}</div>
              </div>
              <button
                className="rounded-md border border-blue-100 px-3 py-2 text-xs font-medium text-slate-600 hover:bg-blue-50"
                onClick={() => logout()}
                type="button"
              >
                Logout
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </header>
  );
}
